import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { AppConfig } from "../models/app-config.model";

export const APP_CONFIG_FILENAME = "app.conf.json";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  private _appConfig: AppConfig | undefined;

  constructor(
    private _httpClient: HttpClient,
    @Inject("BASE_URL") private baseUrl: string,
  ) {}

  public async getAppConfig(): Promise<AppConfig> {
    if (this._appConfig) {
      return Promise.resolve(this._appConfig);
    }
    this._appConfig = await this.fetchAppConf();
    return this._appConfig;
  }

  private fetchAppConf(): Promise<AppConfig> {
    const options = {
      headers: <{ [header: string]: string }>{
        // make sure the app config isn't cached by the browser.
        "Cache-Control":
          "no-cache, no-store, must-revalidate, post-check=0, pre-check=0",
        Pragma: "no-cache",
        Expires: "0",
      },
    };
    return firstValueFrom(
      this._httpClient.get<AppConfig>(
        this.baseUrl + APP_CONFIG_FILENAME,
        options,
      ),
    );
  }
}
